const normalizeIndustryCode = (value: string | number) => {
  const raw = String(value).trim().toLowerCase();
  if (/^-?\d+\.0+$/.test(raw)) {
    return String(parseInt(raw, 10));
  }
  return raw;
};

export const toIndustrySlug = (industryCode: string | number | null | undefined) => {
  if (industryCode === null || industryCode === undefined) return '';
  const normalized = normalizeIndustryCode(industryCode);
  if (!normalized) return '';
  return encodeURIComponent(normalized);
};
